export enum CapacitorPluginsEnum {
    app = 'App',
    shareToApp = 'ShareToApp',
    sslCertificate = 'SslCertificate',
}
